module.exports = __webpack_public_path__ + "img/bg_aviodPhoney_03.d7fe9b38.jpg";